/* eslint-disable no-undef */
import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  useEffect,
} from 'react';
// import { useCookies } from 'react-cookie';
import { api } from '../services/api';

export interface UserInterface {
  id: string;
  name: string;
  nickname: string;
  status: string;
  tag: string;
  senior_id: number;
  flag_1: boolean;
  flag_2: boolean;
  flag_3: boolean;
  flag_4: boolean;
  flag_5: boolean;
  flag_6: boolean;
  flag_7: boolean;
  flag_8: boolean;
  flag_9: boolean;
  goals_and_sub_goals: boolean;
  sector: boolean;
  employers: boolean;
  module_analyze: boolean;
  imports: boolean;
  report: boolean;
  service_send_email: boolean;
  schedule: boolean;
  image: string;
  permissions: string[];
  roles: string[];
  sector_id: string;
  job_position: string;
  email: string;
  ramal: number;
  phone: string;
  access_of_sector: {
    branch: string;
    name: string;
  };
}

interface AuthState {
  token: string;
  user: UserInterface;
}

interface SignInCredentials {
  nickname: string;
  password: string;
}

interface AuthContextData {
  user: UserInterface;
  // eslint-disable-next-line no-unused-vars
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
  // eslint-disable-next-line no-unused-vars
  updateUser(user: UserInterface): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const authChannels = new BroadcastChannel('auth');

const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('@Samasc:token');
    const user = localStorage.getItem('@Samasc:user');

    if (token && user) {
      api.defaults.headers.authorization = `Bearer ${token}`;
      return { token, user: JSON.parse(user) };
    }

    return {} as AuthState;
  });

  useEffect(() => {
    if (data.token !== undefined) {
      api
        .get(`/accesses/show?access_id=${data.user.id}`)
        .then(response => {
          // if (
          //   data.user.permissions !== response.data.permissions ||
          //   response.data.roles !== data.user.roles
          // ) {
          //   console.log('response', response.data);
          //   console.log(
          //     'data.user.permissions',
          //     data.user.permissions !== response.data.permissions,
          //   );
          //   console.log('response.data.permissions', response.data.permissions);
          //   console.log('response.data.roles', response.data.roles);
          //   console.log('data.user.roles', data.user.roles);
          //   console.log('atualizar permissões');
          //   // localStorage.setItem('@Samasc:user', JSON.stringify(response.data));
          // }
          const { token, access, permissions, roles } = response.data;
          const formatData = {
            ...access,
            permissions,
            roles,
          };
          const user = formatData;
          setData({ token, user });
        })
        .catch(() => {
          console.log('deu erro');
          signOut();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.token, data]);

  const signIn = useCallback(async ({ nickname, password }) => {
    const response = await api.post('sessions', {
      nickname,
      password,
    });
    const { token, refresh_token, access, permissions, roles } = response.data;

    const formatData = {
      ...access,
      permissions,
      roles,
    };

    const user = formatData;
    localStorage.setItem('@Samasc:token', token);

    localStorage.setItem('@Samasc:refresh_token', refresh_token);
    localStorage.setItem('@Samasc:user', JSON.stringify(user));

    api.defaults.headers.authorization = `Bearer ${token}`;

    setData({ token, user });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@Samasc:token');
    localStorage.removeItem('@Samasc:refresh_token');
    localStorage.removeItem('@Samasc:user');

    // await authChannels.postMessage('signOut');

    setData({} as AuthState);
  }, []);

  useEffect(() => {
    authChannels.onmessage = message => {
      switch (message.data) {
        case 'signOut':
          signOut();
          break;
        default:
          break;
      }
    };
  }, [signOut]);

  const updateUser = useCallback(
    (user: UserInterface) => {
      localStorage.setItem('@Samasc:user', JSON.stringify(user));
      setData({
        token: data.token,
        user,
      });
    },
    [setData, data.token],
  );

  return (
    <AuthContext.Provider
      value={{ user: data.user, signIn, signOut, updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };
